export const ANALYTICS_EVENTS = {
  FETCH_PREFERENCES: "fetch-preferences",
  UPDATE_PREFERENCES: "update-preferences",
};
